<script>
  import { GameLauncher } from '@/mixins/game-launcher';
  import socials from '@/data/socials';
  import SliderCard from '@/components/cards/SliderCard.vue';
  import IconFacebook from '@/assets/images/svg/icons/mq-social-fb.svg';
  import IconX from '@/assets/images/svg/icons/mq-social-x.svg';
  import IconInstagram from '@/assets/images/svg/icons/mq-social-insta.svg';
  import IconYoutube from '@/assets/images/svg/icons/mq-social-yt.svg';
  import IconTelegram from '@/assets/images/svg/icons/mq-social-tg.svg';
  import IconDiscord from '@/assets/images/svg/icon-discord.svg';
  import IconQCCoin from '@/assets/images/svg/icon-qc-coin.svg';
  import IconMCCoin from '@/assets/images/svg/icon-mc-coin.svg';
  import { allGames } from '@/data/games';

  export default {
    name: 'AboutUs',
    mixins: [GameLauncher],
    metaInfo: {
      title: 'about-us',
    },
    components: {
      SliderCard,
      IconDiscord,
      IconQCCoin,
      IconMCCoin,
    },
    data() {
      return {
        discordUrl: socials.discordUrl,
        socialItems: [
          { label: 'Facebook', link: socials.facebookUrl, icon: IconFacebook, testId: 'facebook-link' },
          { label: 'X.com', link: socials.twitterUrl, icon: IconX, testId: 'x-link' },
          { label: 'Instagram', link: socials.instagramUrl, icon: IconInstagram, testId: 'instagram-link' },
          { label: 'youtube', link: socials.youtubeUrl, icon: IconYoutube, testId: 'youtube-link' },
          { label: 'telegram', link: socials.telegramUrl, icon: IconTelegram, testId: 'telegram-link' },
        ],
        gameSlides: {
          pvp: [
            {
              img: '/images/about/games/pvp-max-blast-champs.webp',
              title: 'Max Blast Champs',
            },
            {
              img: '/images/about/games/pvp-multi-mines.webp',
              title: 'Multi Mines',
            },
            {
              img: '/images/about/games/pvp-multi-plinko.webp',
              title: 'Multi Plinko',
            },
          ],
          fp: [
            {
              img: '/images/about/games/fp-sector-x.webp',
              title: 'Sector X',
            },
            {
              img: '/images/about/games/fp-dragon-stone.webp',
              title: 'Dragon Stone',
            },
            // {
            //   img: '/images/about/games/fp-fast-mines.webp',
            //   title: 'Fast Mines',
            // },
            {
              img: '/images/about/games/fp-mission-amazon.webp',
              title: 'Mission Amazon',
            },
            // {
            //   img: '/images/about/games/fp-olympus-plinko.webp',
            //   title: 'Olympus Plinko',
            // },
            // {
            //   img: '/images/about/games/fp-triple-max-blast.webp',
            //   title: 'Triple Max Blast',
            // },
          ],
        },
      };
    },

    computed: {
      fpGames: () => allGames.filter((game) => !game.comingSoon && game.isFastPlay),
      pvpGames: () => allGames.filter((game) => !game.comingSoon && !game.isFastPlay),
    },

    methods: {
      onGameCardClick(gameCard, gameList) {
        this.handleGameClick(gameList.find((game) => game.title === gameCard.title));
      },
    },
  };
</script>

<template>
  <div class="about-page">
    <div class="about-content gap">
      <div class="card-purple intro mb-6 pa-10">
        <h1 class="text-title mb-6">INTRODUCING MAXQUEST</h1>
        <h2 class="text-title mb-6">EXCLUSIVE ORIGINAL GAMES</h2>
        <p class="mb-0">
          MaxQuest stands as the foremost Player vs Player (PvP) game platform, introducing a variety of original and
          exclusive game concepts that are the 1st of its kind.
        </p>
        <img
          class="characters position-absolute right-0 bottom-0 hide--600"
          src="/images/about/characters.webp"
          alt="Game Characters"
          draggable="false"
        />
        <img
          class="position-absolute astronaut hide--600"
          src="/images/about/astronaut.webp"
          alt="Astronaut Character"
          draggable="false"
        />
        <img
          class="characters position-absolute right-0 bottom-0 show--600"
          src="/images/about/MQ-about-us-banner-mobile.webp"
          alt="Game Characters"
          draggable="false"
        />
      </div>
      <div class="d-grid content gap">
        <div class="card-purple grid pvp grid-col-1 align-center">
          <SliderCard
            class="mobile"
            swiper-id="pvp"
            :slides="gameSlides.pvp"
            @click="onGameCardClick($event, pvpGames)"
          />
          <div class="text pl-8">
            <h2 class="text-title mobile-center">PLAYER vs PLAYER</h2>
            <p>
              All Player vs Player games are developed in-house by the MaxQuest team, enriched with engaging,
              competitive community features, empowering users with a new experience to play with others and earn crypto
              rewards.
              <br />
              <br />
              Experience the 1st PLAYER vs PLAYER version of popular games like
              <b>Crash (Max Blast Champions)</b>
              ,
              <b>Plinko (MultiPlinko)</b>
              and
              <b>Mines (MultiMines)</b>
              , and win the prize pot contributed by the participating players.
            </p>
          </div>
        </div>
        <div class="card-purple fp grid grid-col-1 align-center">
          <div class="text pl-10">
            <h2 class="text-title mobile-center">FISH TABLE GAMES</h2>
            <p>
              MaxQuest's dynamic Fish style shooter games - <b>Sector X</b>, <b>DragonStone</b> and <b>Mission Amazon</b> - are innovative, original versions of these popular concepts.
            </p>
          </div>
          <SliderCard class="mobile" swiper-id="fp" :slides="gameSlides.fp" @click="onGameCardClick($event, fpGames)" />
        </div>
        <div class="card-purple caf grid grid-col-1 py-12 pr-15">
          <div class="image-wrapper">
            <img
              class="position-absolute bottom-0"
              src="/images/about/throphy-and-astronaut.webp"
              alt="Throphy and Astronaut"
              draggable="false"
            />
          </div>
          <div class="text">
            <h2 class="text-title mobile-center">CHALLENGE FRIENDS</h2>
            <div>
              <p class="mb-10">
                MaxQuest is the gold standard in transparency, exclusivity and provably fair games. With
                <b>CHALLENGE FRIENDS</b>
                , you can create your own ringfenced game rooms with ONLY your invited guests. This means each win is
                verified and confirmed as real, by your friends or you!
              </p>
              <p class="mb-0">
                No more doubts about "unfair" games, you control the action with MaxQuest's
                <b>CHALLENGE FRIENDS</b>
                .
              </p>
            </div>
          </div>
        </div>
        <div class="socials-wrapper d-flex">
          <div class="card-purple socials grid-row-1 grid-col-2 d-flex flex-column">
            <h3 class="text-title mb-5 mobile-center">JOIN THE MAXQUEST COMMUNITY</h3>
            <p>
              Join our
              <a :href="discordUrl">Discord</a>
              and follow us on social media for sneak peaks, free stuff and much more!
            </p>
            <a :href="discordUrl" class="mt-auto mb-6 cursor-pointer cta-discord d-flex justify-center align-center">
              <IconDiscord />
              <span>Join Us on Discord</span>
            </a>
            <div class="d-flex justify-space-between">
              <a
                v-for="item in socialItems"
                :key="item.label"
                :data-test-id="item.testId"
                class="footer-social-btn"
                :href="item.link"
                target="_blank"
              >
                <component :is="item.icon" />
              </a>
            </div>
          </div>
          <div class="card-purple socials raf d-flex flex-column grid-row-2 grid-col-2">
            <h3 class="text-title mb-5 mobile-center">REFER A FRIEND</h3>
            <p>
              Invite friends and acquaintances to MaxQuest for an expansive PLAYER vs PLAYER experience and get rewarded
              up to 10% commission for each referral. Join the REFER A FRIEND program today.
            </p>
            <router-link
              :to="{ name: 'referfriends' }"
              class="mt-auto cursor-pointer cta-filled d-flex justify-center align-center"
            >
              <span>Refer a Friend</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  h1,
  h2,
  h3,
  h4 {
    font-weight: 800;
    position: relative;
    z-index: 2;
    margin-bottom: 0;
    @media (min-width: 1200px) {
      margin-bottom: 24px;
    }
  }
  h1 {
    line-height: 1;
    color: #fff;
    font-size: 48px;
    @media (min-width: 1025px) {
      font-size: 60px;
    }
  }
  h2 {
    font-size: 40px;
    line-height: 48px;
  }
  h3 {
    font-size: 32px;
    line-height: 1;
  }
  h4 {
    color: #fff;
  }
  img {
    user-select: none;
  }
  .bottom-0 {
    bottom: 0;
  }
  .right-0 {
    right: 0;
  }
  .gap {
    row-gap: 24px;
    column-gap: 40px;
  }
  .link {
    color: #f8bf1e !important;
    text-decoration: underline;
  }
  .cta-discord {
    background-color: rgba(#fff, 0.1);
    border: 1px solid #f8bf1e;
    border-radius: 10px;
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    gap: 4px;
    svg {
      width: 27px;
      position: relative;
      //top: 2px;
    }
  }
  .cta-filled {
    background-color: #f8bf1e;
    padding: 16px 32px;
    color: #1c0630 !important;
    font-size: 16px;
    font-weight: 600;
    border-radius: 10px;
  }
  .about-page {
    background-color: #1c0630;
    display: flex;
    justify-content: center;
    padding: 20px;
    @media (min-width: 1025px) {
      padding: 40px 40px 62px;
    }
    .about-content {
      width: 100%;
      @media (min-width: 1600px) {
        max-width: 1448px;
      }
      & > .d-grid {
        grid-template-columns: 1fr 1fr;
        @media (min-width: 1800px) {
          grid-template-columns: 960px 1fr;
          .grid-col-1 {
            grid-column: 1;
          }
          .grid-col-2 {
            grid-column: 2;
          }
          .grid-row-1 {
            grid-row: 1;
          }
          .grid-row-2 {
            grid-row: 2;
          }
        }
      }
    }
  }

  .card-purple {
    //padding: 40px 16px;
    position: relative;
    max-width: 100%;
    padding: 20px 30px;
    container: cardpurple/inline-size;

    &.grid {
      display: grid;

      @media (min-width: 1200px) {
        &.pvp,
        &.fp,
        &.caf {
          gap: 24px;
          column-gap: 30px;

          h2 {
            align-self: flex-end;
          }
        }
        &.pvp {
          grid-template-columns: 1fr 3fr;
          div:not(.text) {
            grid-row: 1/-1;
            grid-column: 1;
          }
        }
        &.caf {
          grid-template-columns: 2fr 3fr;
          div.image-wrapper {
            display: flex;
            justify-content: center;
            grid-row: 1/-1;
            grid-column: 1;
          }
        }
        &.fp {
          grid-template-columns: 3fr 1fr;
          div:not(.text) {
            grid-row: 1/-1;
            grid-column: 2;
          }
        }
      }
      @media (max-width: 1199px) {
        padding: 20px !important;
        gap: 24px;
        grid-template-columns: 1fr;

        div.text {
          display: contents;
          h2 {
            grid-row: 1;
            //text-align: center;
            font-size: 32px;
          }
          p {
            grid-row: 3;
            padding: 0 20px;
          }
        }
        div:not(.text) {
          grid-row: 2;
        }
        div.image-wrapper {
          display: contents;
        }
        .slides {
          grid-row: 2;
        }
      }
    }
    border-radius: 10px;
    color: #fff;
    background-color: #24073d;
    background-image: linear-gradient(rgba(#350f53, 0), rgba(#350f53, 0.6));

    p {
      @media (min-width: 1200px) {
        max-width: 520px;
      }
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      padding: 0;
      color: rgba(#fff, 0.8);
      position: relative;
      z-index: 2;
      b {
        font-weight: 500;
        color: #fff;
      }
    }
    &.socials {
      &:before {
        display: block;
        content: '';
        background-image: linear-gradient(rgba(28, 6, 48, 0) 0%, #12031f 80%);
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 10px;
      }
      &:not(.raf) {
        background-image: url(/images/about/discord.webp);
        background-position: bottom center;
      }
      p {
        color: #fff;
      }
      padding: 40px;
      * {
        position: relative;
      }
    }
    &.caf {
      img {
        max-height: 80%;
      }
      @media (max-width: 1199px) {
        &:before {
          display: block;
          content: '';
          background-image: linear-gradient(rgba(#1c0630, 0), #1c0630 80%);
          width: 100%;
          height: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          border-radius: 10px;
        }
        background-image: url('/images/about/throphy-and-astronaut.webp');
        background-position: center;
        img {
          display: none;
        }
        h2 {
          margin-bottom: 256px !important;
        }
      }
    }
    &.intro {
      img.astronaut {
        right: 0;
        top: -20px;
        width: 130px;
        transform: rotate(2deg);
      }
      p {
        line-height: 30px;
        font-size: 20px;
        color: #fff;
      }
      @media (max-width: 1600px) and (min-width: 601px) {
        img:first-of-type {
          max-height: 80%;
          max-width: 70cqw;
          object-fit: cover;
          //opacity: 0.7;
        }
        h1 {
          text-align: unset;
        }
        p {
          //max-width: 500px;
          margin-bottom: 100px !important;
        }
        img.astronaut {
          bottom: 10cqw;
          top: unset;
        }
      }

      @media (max-width: 1199px) {
        p {
          max-width: 500px;
          text-align: left;
        }
        img.astronaut {
          right: 12px;
          width: 15cqw;
          bottom: 10cqw;
          top: unset;
        }
      }
      @media (max-width: 768px) {
        h1,
        h2,
        p {
          text-align: center;
          max-width: unset;
        }
        h2 {
          font-size: 24px;
        }
      }
      @media (max-width: 600px) {
        .hide--600 {
          display: none !important;
        }
        overflow: hidden;
        padding: 40px 16px !important;
        p {
          font-size: 16px;
          margin-bottom: 55cqw !important;
        }
        img.astronaut {
          min-width: 100px;
          bottom: 30cqw;
          top: unset;
        }
        img:first-of-type {
          width: 120%;
          max-width: 120%;
          left: -10%;
        }
      }
    }
  }
  @media (max-width: 1800px) {
    .d-grid.content {
      & > div {
        grid-column: 1/3;
      }
    }
    .socials {
      grid-column: 1/1 !important;
    }
    .raf {
      grid-column: 2/2 !important;
    }
  }
  @media (max-width: 1199px) {
    .mobile-center {
      text-align: center !important;
    }
    .d-grid.content {
      display: flex !important;
      flex-direction: column;
    }
  }
  @media (max-width: 768px) {
    .hide--mobile {
      display: none !important;
    }
    .center--mobile {
      justify-content: center !important;
    }
    .socials p {
      text-align: center;
      margin-bottom: 60px;
    }
    .socials-wrapper {
      display: contents !important;
    }
  }
  @media (max-width: 380px) {
    .card-purple {
      padding: 8px !important;
    }
    .hide--fake {
      display: none !important;
    }
    .slider-wrapper {
      max-width: 240px !important;
      scale: 0.85;
    }
    .coin-large {
      width: 100% !important;
      & + div {
        padding: 4px !important;
      }
    }
  }
  @media (min-width: 769px) {
    .hide--desktop {
      display: none !important;
    }

    .socials-wrapper {
      gap: 24px;
      & > div {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    .socials-wrapper {
      display: contents !important;
    }
  }
  .mobile {
    width: 100%;
    max-width: 280px;
  }
  @media (max-width: 1199px) and (min-width: 600px) {
    .mobile {
      width: calc(100cqw - 40px);
      max-width: unset;
    }
  }

  @container cardpurple (min-width: 1024px) and (max-width:1300px) {
    .characters {
      max-width: 60cqw;
    }
  }
  @media (max-width: 600px) {
    .hide--600 {
      display: none !important;
    }
    .show--600 {
      display: block !important;
    }
  }
  @media (min-width: 601px) {
    .hide--600 {
      display: block !important;
    }
    .show--600 {
      display: none !important;
    }
  }
</style>
